<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <contest-select-panel [competitionId]="competitionId"
                          [contest]="contest"
                          [mobileView]="mobileView"
                          [showDetails]="false"
                          (selected)="contestSelected($event)"></contest-select-panel>

    <div *ngIf="contest" fxLayout="row wrap" fxLayout.lt-md="column" class="stats-holder">
      <bar-chart fxFlex="49%"
                 class="stats-card"
                 title="Enrollments"
                 i18n-title="Stats|Enrol stats title@@stats-enrol-stats-title"
                 noContentTitle="Enrollment stats data is missing for the selected contest"
                 i18n-noContentTitle="Stats|Enrol stats missing title@@stats-enrol-stats-missing-title"
                 noContentDetails="Stats will be added when students start to enrol for the contest"
                 i18n-noContentDetails="Stats|Region Enrol stats missing details@@stats-region-enrol-stats-missing-details"
                 [labels]="paymentStatsLabels"
                 backgroundColor="#039be5"
                 hoverBackgroundColor="#0277bd"
                 [data]="paymentStats"></bar-chart>

      <div class="fill-space"></div>

      <doughnut-chart fxFlex="49%"
                      class="stats-card grade-stats-card"
                      title="Enrollment by Grade"
                      i18n-title="Stats|School Enrol stats grade chart title@@stats-school-enrol-stats-grade-chart-title"
                      noContentTitle="Grade enrollment stats data is missing for the selected contest"
                      i18n-noContentTitle="Stats|Grade Enrol stats missing title@@stats-grade-enrol-stats-missing-title"
                      noContentDetails="Stats will be added when students start to enrol for the contest"
                      i18n-noContentDetails="Stats|Grade Enrol stats missing details@@stats-grade-enrol-stats-missing-details"
                      [labels]="gradeStatsLabels"
                      [data]="gradeStats"></doughnut-chart>

      <div class="fill-space"></div>

      <doughnut-chart fxFlex="49%"
                      class="stats-card status-stats-card"
                      title="Participant Status"
                      i18n-title="Stats|School Enrol stats status chart title@@stats-school-enrol-stats-status-chart-title"
                      noContentTitle="Status enrollment stats data is missing for the selected contest"
                      i18n-noContentTitle="Stats|Status Enrol stats missing title@@stats-status-enrol-stats-missing-title"
                      noContentDetails="Stats will be added when students start to enrol for the contest"
                      i18n-noContentDetails="Stats|Status Enrol stats missing details@@stats-status-enrol-stats-missing-details"
                      [labels]="participantStatusStatsLabels"
                      [data]="participantStatusStats"></doughnut-chart>

      <div class="fill-space"></div>

      <bar-chart fxFlex="49%"
                 class="stats-card status-stats-card"
                 title="Other Users Status"
                 i18n-title="Stats|School enrol other users status chart title@@stats-enrol-other-users-chart-title"
                 noContentTitle="Status enrollment stats data is missing for the selected contest"
                 i18n-noContentTitle="Stats|Status Enrol stats missing title@@stats-status-enrol-stats-missing-title"
                 noContentDetails="Stats will be added when students start to enrol for the contest"
                 i18n-noContentDetails="Stats|Status Enrol stats missing details@@stats-status-enrol-stats-missing-details"
                 [labels]="otherUserStatusStatsLabels"
                 backgroundColor="#4caf50"
                 hoverBackgroundColor="#388e3c"
                 [data]="otherUserStatusStats"></bar-chart>

      <div class="fill-space"></div>

      <bar-chart fxFlex="33%"
                 class="stats-card"
                 title="Contest Participation"
                 i18n-title="Stats|Contest participation stats title@@stats-contest-participation-stats-title"
                 noContentTitle="Contest participation stats data is missing for the selected contest"
                 i18n-noContentTitle="Stats|Contest participation stats missing title@@stats-contest-participation-stats-missing-title"
                 noContentDetails="Stats will be added when students start to participate in the contest"
                 i18n-noContentDetails="Stats|Participate stats missing details@@stats-participate-stats-missing-details"
                 [labels]="examParticipantStatsLabels"
                 backgroundColor="#ff9800"
                 hoverBackgroundColor="#f57c00"
                 [data]="examParticipantStatusStats"></bar-chart>

      <div class="fill-space"></div>

      <doughnut-chart fxFlex="33%"
                      class="stats-card grade-stats-card"
                      title="Participation by Grade"
                      i18n-title="Stats|Contest participation grade chart title@@stats-contest-participation-grade-chart-title"
                      noContentTitle="Contest participation stats data is missing for the selected contest"
                      i18n-noContentTitle="Stats|Contest participation stats missing title@@stats-contest-participation-stats-missing-title"
                      noContentDetails="Stats will be added when students start to participate in the contest"
                      i18n-noContentDetails="Stats|Participate stats missing details@@stats-participate-stats-missing-details"
                      [labels]="examGradeStatsLabels"
                      [data]="examGradeStats"></doughnut-chart>

      <div class="fill-space"></div>

      <polar-chart fxFlex="33%"
                   class="stats-card grade-stats-card"
                   title="Participation Points"
                   i18n-title="Stats|Contest participation points chart title@@stats-contest-participation-points-chart-title"
                   noContentTitle="Contest participation stats data is missing for the selected contest"
                   i18n-noContentTitle="Stats|Contest participation stats missing title@@stats-contest-participation-stats-missing-title"
                   noContentDetails="Stats will be added when students start to participate in the contest"
                   i18n-noContentDetails="Stats|Participate stats missing details@@stats-participate-stats-missing-details"
                   [labels]="examPointsGradeStatsLabels"
                   [data]="examPointsGradeStats"></polar-chart>
    </div>

  </div>
</permission-checker>
